export const options = [
  {
    id: 1,
    option: "",
    isCorrect: false,
  },
  {
    id: 2,
    option: "",
    isCorrect: false,
  },
  {
    id: 3,
    option: "",
    isCorrect: false,
  },
  {
    id: 4,
    option: "",
    isCorrect: false,
  },
];
